__turbopack_context__.v({
  "group": "home-page-module__UZ09SG__group",
  "groupHeader": "home-page-module__UZ09SG__groupHeader",
  "groupTitle": "home-page-module__UZ09SG__groupTitle",
  "home": "home-page-module__UZ09SG__home",
  "search": "home-page-module__UZ09SG__search",
  "stack": "home-page-module__UZ09SG__stack",
  "tiles": "home-page-module__UZ09SG__tiles",
  "visuallyHidden": "home-page-module__UZ09SG__visuallyHidden",
});
